
export default {
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    cancelAction: {
      type: Object,
      default: () => ({}),
    },
    hideCancelAction: {
      type: Boolean,
      default: false,
    },
    hideOverlay: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '481',
    },
    value: {
      type: Boolean,
      default: false,
    },
    closeIcon: {
      type: Boolean,
      default: false,
    },
    closeIconSize: {
      type: String,
      default: 'small',
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    contentClass: String,
    persistent: {
      type: Boolean,
      default: false,
    },
    noClickAnimation: {
      type: Boolean,
      default: false,
    },
    retainFocus: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showPopup: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    hasPopupHeader() {
      return !!(this.header || this.$slots['popup-header']);
    },
    computedActions() {
      return [
        ...this.actions,
        ...(!this.hideCancelAction ? [{
          text: 'Cancel',
          value: false,
          isDestructive: true,
          ...this.cancelAction,
        }] : []),
      ];
    },
  },
  methods: {
    onActionClick(event) {
      this.$emit('click:action', event);
    },
  },
};
